var _rect, _path, _path2;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgAvatarDefaultNamePlate(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 152,
    height: 193,
    viewBox: "0 0 152 193",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    y: 0.527344,
    width: 152,
    height: 192,
    fill: "#F2F2F2"
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M76.0004 91.6248C88.0581 91.6248 97.8328 82.249 97.8328 70.6835C97.8328 59.1179 88.0581 49.7422 76.0004 49.7422C63.9427 49.7422 54.168 59.1179 54.168 70.6835C54.168 82.249 63.9427 91.6248 76.0004 91.6248Z",
    fill: "white"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M28.4676 127.009C31.9029 109.157 52.3321 95.4631 76.0143 95.1914C99.6964 95.4903 120.126 109.157 123.561 127.009C124.108 129.808 122.649 132.335 119.578 133.938C95.5619 146.437 56.4666 146.437 32.4197 133.938C29.3492 132.335 27.89 129.808 28.4372 127.009H28.4676Z",
    fill: "white"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgAvatarDefaultNamePlate);
export default __webpack_public_path__ + "static/media/avatar_default_name_plate.1318ebd22c7a42739b72b7854e9c5e4c.svg";
export { ForwardRef as ReactComponent };